module.exports = __webpack_public_path__ + "static/GustavA-c293fb0fa2b4f18ffdc391b76c5a610a.gif";